import React from 'react';
import classNames from 'classnames'
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import immutable from 'immutable';

export default class MultiCheckbox extends React.Component {

	handleClick(e, option) {
		let newValue = this.props.value;
		if (!newValue) {
			newValue = immutable.List();
		}
		const checked = e.target.checked;
		if (checked) {
			newValue = newValue.push(option.id);
		}
		else {
			const index = newValue.indexOf(option.id);
			if (index != -1) {
				newValue = newValue.delete(index);
			}			
		}
		if (this.props.onChange) {
			this.props.onChange(newValue)
		}
		if (this.props.onBlur) {
			this.props.onBlur(newValue)
		}
	}
	getError() {
		return this.props.error && this.props.error[0];
	}

	renderInputGroup() {

		let val = this.props.value;
		if (!val) {
			val = [];
		}
		else {
			val = val.toJS();
		}
		const checkboxes = this.props.options.map((option) => {
			return (
				<span key={option.id} className="option">
					<label>
						<input type="checkbox" checked={val.indexOf(option.id) != -1} onClick={(e) => this.handleClick(e, option)} /> {option.title}
					</label>
				</span>
			);
		});

		const tooltip = this.props.help ? <Tooltip id={this.props.help}>{this.props.help}</Tooltip> : null;
		const help = this.props.help ? <OverlayTrigger key="help" placement='top' overlay={tooltip}>
			<span className="fa fa-question-circle position-right" style={{top: -1}} />
		</OverlayTrigger> : null;

		return help ? (
			<div key="group">
				{checkboxes}
				{help}
			</div>
		) : checkboxes;
	}

	renderWrapper(children) {

		const classes = {
			'has-error': this.getError(),
			'multicheckbox' : true
		};

		return <span className={classNames(classes, this.props.wrapperClassName)} key="wrapper">
				{children}
				</span>
	}

	renderError() {
		const error = this.getError();
		return error ? (
			<span className="error-block" key="error">{error}</span>
		) : null;
	}

	render() {
		return (
			this.renderWrapper([
				this.renderInputGroup(),
				this.renderError()
			])
		);
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/MultiCheckbox.js